import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { DefaultHabitService } from 'src/app/core/services/default-habit.service';
import { Habit } from 'src/app/habit.model';
import { HabitValidators } from '../habit/habit.validators';

@Component({
  templateUrl: './config.component.html',
  styleUrls: ['./config.component.scss'],
})
export class ConfigComponent implements OnInit {
  @Input()
  habits$: Observable<{ [key: string]: Habit }> = of({});

  @Output()
  closeConfig: EventEmitter<boolean> = new EventEmitter();

  @Output()
  deleteDefaultHabit: EventEmitter<Habit> = new EventEmitter();

  @Output()
  addDefaultHabit: EventEmitter<string> = new EventEmitter();

  form = this.fb.group({
    habit: [
      '',
      [Validators.required],
      [
        HabitValidators.habitExistValidator(
          this.defaultHabitService.getDefaultHabits()
        ),
      ],
    ],
  });

  constructor(
    private fb: FormBuilder,
    private defaultHabitService: DefaultHabitService
  ) {}

  ngOnInit(): void {}

  trackByFn = (index: number, obj: any) => {
    return obj.key;
  }

  emitCloseModal(): void {
    this.closeConfig.emit(true);
  }

  emitDeleteDefaultHabit(habit: Habit): void {
    this.deleteDefaultHabit.emit(habit);
  }

  emitAddDefaultHabit(): void {
    this.addDefaultHabit.emit(this.form.value.habit);
  }
}
